// import { Box, Container, Typography } from "@mui/material";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination, Autoplay } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/pagination";

// const industries = [
//   "Banking & Financial Services",
//   "Insurance",
//   "Healthcare & Life Sciences",
//   "Pharmaceuticals & Biotech",
//   "Retail & E-commerce",
//   "Manufacturing",
//   "Supply Chain & Logistics",
//   "Telecommunications",
//   "Energy & Utilities",
//   "Oil & Gas",
//   "Automotive",
//   "Aerospace & Defense",
//   "Media & Entertainment",
//   "Travel & Hospitality",
//   "Real Estate",
//   "Government & Public Sector",
//   "Smart Cities",
//   "Education & Universities",
//   "EdTech Organizations",
//   "Research Institutions",
//   "Technology & SaaS",
//   "Professional Services",
//   "Non-Profit Organizations"
// ];

// const IndustriesSlider = () => {
//   return (
//     <Box
//       sx={{
//         py: 12,
//         background: "radial-gradient(circle at top, #020617, #000000)"
//       }}
//     >
//       <Container>
//         <Typography
//           variant="h3"
//           fontWeight={800}
//           textAlign="center"
//           color="white"
//           mb={3}
//         >
//           Industries We Empower
//         </Typography>

//         <Typography
//           textAlign="center"
//           sx={{ color: "rgba(255,255,255,0.7)" }}
//           mb={6}
//           maxWidth={900}
//           mx="auto"
//         >
//           Our AI solutions empower enterprises, public sector bodies, and educational
//           organizations across diverse industries worldwide.
//         </Typography>

//         <Swiper
//           modules={[Pagination, Autoplay]}
//           spaceBetween={24}
//           slidesPerView={1}
//           autoplay={{ delay: 3500, disableOnInteraction: false }}
//           pagination={{ clickable: true }}
//           breakpoints={{
//             600: { slidesPerView: 2 },
//             900: { slidesPerView: 3 },
//             1200: { slidesPerView: 4 }
//           }}
//         >
//           {industries.map((industry, index) => (
//             <SwiperSlide key={index}>
//               <Box
//                 sx={{
//                   p: 3,
//                   borderRadius: 3,
//                   textAlign: "center",
//                   minHeight: 100,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   color: "white",
//                   fontWeight: 600,
//                   background:
//                     "linear-gradient(135deg, rgba(59,130,246,0.12), rgba(99,102,241,0.12))",
//                   border: "1px solid rgba(255,255,255,0.08)",
//                   transition: "all 0.3s ease",
//                   cursor: "pointer",
//                   "&:hover": {
//                     boxShadow: "0 0 25px rgba(59,130,246,0.6)",
//                     transform: "translateY(-3px)"
//                   }
//                 }}
//               >
//                 {industry}
//               </Box>
//             </SwiperSlide>
//           ))}
//         </Swiper>

//         {/* Swiper pagination dark theme */}
//         <style>
//           {`
//             .swiper-pagination-bullet {
//               background: rgba(255,255,255,0.3);
//             }
//             .swiper-pagination-bullet-active {
//               background: #3b82f6;
//             }
//           `}
//         </style>
//       </Container>
//     </Box>
//   );
// };

// export default IndustriesSlider;







/**
 * IndustriesGrid.jsx
 * ─────────────────────────────────────────────────────────────
 * Premium bento-grid "Industries We Empower" section.
 * Zero Swiper dependency. React + MUI + Framer Motion.
 * Designed to sit directly below TrustedBy.jsx.
 *
 * Dependencies:
 *   framer-motion   npm install framer-motion
 *   @mui/material   npm install @mui/material @emotion/react @emotion/styled
 *
 * Usage:
 *   import IndustriesGrid from "./IndustriesGrid";
 *   <IndustriesGrid />
 */

import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";

/* ─── Fonts + CSS-only scan-line animation ───────────────────────────────── */
const Styles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,750&family=DM+Sans:wght@300;400;500&display=swap');

    /* Scan-line sweep on card hover */
    @keyframes ig-scanDown {
      0%   { top: 0px;   opacity: 1; }
      70%  { opacity: .7; }
      100% { top: 150px; opacity: 0; }
    }

    .ig-card { position: relative; }

    .ig-scan {
      position: absolute;
      left: 0; right: 0; top: 0;
      height: 2px;
      background: linear-gradient(90deg, transparent, rgba(30,144,255,.75), transparent);
      opacity: 0;
      pointer-events: none;
      z-index: 10;
    }

    .ig-card:hover .ig-scan {
      opacity: 1;
      animation: ig-scanDown .65s ease-in-out forwards;
    }

    /* Subtle noise-grain texture overlay */
    .ig-grain {
      position: absolute; inset: 0;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
      opacity: .028;
      mix-blend-mode: overlay;
      pointer-events: none;
    }

    /* Reduce motion for accessibility & battery */
    @media (prefers-reduced-motion: reduce) {
      .ig-card:hover .ig-scan { animation: none; opacity: 0; }
    }

    /* Prevent horizontal overflow on small screens */
    * { box-sizing: border-box; }
  `}</style>
);

/* ─── Micro SVG icon set — 18 × 18 viewBox, stroke-only ─────────────────── */
const Icon = ({ children }) => (
  <svg viewBox="0 0 18 18" fill="none" width="100%" height="100%"
    strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

const ICONS = {
  banking:      <Icon><path d="M3 14h12M4 14V9M7 14V7M10 14V9M14 14V5M9 2L16 7H2L9 2Z" stroke="currentColor" strokeWidth="1.25"/></Icon>,
  insurance:    <Icon><path d="M9 2L14.5 4.5V9.5C14.5 12.5 12 14.5 9 16C6 14.5 3.5 12.5 3.5 9.5V4.5L9 2Z" stroke="currentColor" strokeWidth="1.25"/></Icon>,
  health:       <Icon><circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="1.25"/><path d="M9 5.5V12.5M5.5 9H12.5" stroke="currentColor" strokeWidth="1.5"/></Icon>,
  pharma:       <Icon><path d="M6.5 2H11.5M8 2V5.5L5 13H13L10 5.5V2" stroke="currentColor" strokeWidth="1.25"/></Icon>,
  retail:       <Icon><path d="M4.5 6.5H13.5L12 14H6L4.5 6.5Z" stroke="currentColor" strokeWidth="1.25"/><path d="M7 6.5C7 5.1 7.8 3 9 3C10.2 3 11 5.1 11 6.5" stroke="currentColor" strokeWidth="1.25"/></Icon>,
  manufacturing:<Icon><circle cx="9" cy="9" r="2.8" stroke="currentColor" strokeWidth="1.25"/><path d="M9 2.5V5M9 13V15.5M2.5 9H5M13 9H15.5M4 4L5.5 5.5M12.5 12.5L14 14M14 4L12.5 5.5M5.5 12.5L4 14" stroke="currentColor" strokeWidth="1.1"/></Icon>,
  supply:       <Icon><path d="M2 9H14M10 5L14 9L10 13" stroke="currentColor" strokeWidth="1.3"/><circle cx="4.5" cy="9" r="1.8" stroke="currentColor" strokeWidth="1.2"/></Icon>,
  telecom:      <Icon><path d="M1.5 14.5C3.5 9 6 6.5 9 6.5C12 6.5 14.5 9 16.5 14.5M4.5 14.5C6 10.5 7.5 9 9 9C10.5 9 12 10.5 13.5 14.5" stroke="currentColor" strokeWidth="1.25"/><circle cx="9" cy="14.5" r="1.2" fill="currentColor"/></Icon>,
  energy:       <Icon><path d="M11 2L5 10H9.5L7 16L13 8H8.5L11 2Z" stroke="currentColor" strokeWidth="1.25"/></Icon>,
  oil:          <Icon><path d="M9 3.5C9 3.5 4.5 7.5 4.5 11C4.5 13.5 6.5 15.5 9 15.5C11.5 15.5 13.5 13.5 13.5 11C13.5 7.5 9 3.5 9 3.5Z" stroke="currentColor" strokeWidth="1.25"/><path d="M7.2 11C7.2 9.8 8 9 9 9" stroke="currentColor" strokeWidth="1.2"/></Icon>,
  auto:         <Icon><circle cx="9" cy="9" r="6.5" stroke="currentColor" strokeWidth="1.25"/><circle cx="9" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.25"/><path d="M9 2.5V6.5M9 11.5V15.5M2.5 9H6.5M11.5 9H15.5" stroke="currentColor" strokeWidth="1.1"/></Icon>,
  aerospace:    <Icon><path d="M9 2L11 7V12L9 14L7 12V7L9 2Z" stroke="currentColor" strokeWidth="1.25"/><path d="M7 8L4 10.5L5 12L7 11M11 8L14 10.5L13 12L11 11" stroke="currentColor" strokeWidth="1.2"/><path d="M7 13L8 16H10L11 13" stroke="currentColor" strokeWidth="1.2"/></Icon>,
  media:        <Icon><circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="1.25"/><path d="M7.5 6.5L13 9L7.5 11.5V6.5Z" stroke="currentColor" strokeWidth="1.25"/></Icon>,
  travel:       <Icon><circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="1.25"/><path d="M2 9H16M9 2C9 2 6.5 5 6.5 9C6.5 13 9 16 9 16C9 16 11.5 13 11.5 9C11.5 5 9 2 9 2Z" stroke="currentColor" strokeWidth="1.2"/></Icon>,
  realestate:   <Icon><path d="M2.5 9.5L9 3L15.5 9.5M4.5 8.5V15H13.5V8.5M7 15V11H11V15" stroke="currentColor" strokeWidth="1.25"/></Icon>,
  govt:         <Icon><path d="M2.5 14H15.5M2.5 7H15.5M9 2L15.5 7H2.5L9 2Z" stroke="currentColor" strokeWidth="1.25"/><path d="M4.5 7V14M7.5 7V14M10.5 7V14M13.5 7V14" stroke="currentColor" strokeWidth="1.2"/></Icon>,
  smartcity:    <Icon><rect x="2" y="8.5" width="4" height="6" rx=".5" stroke="currentColor" strokeWidth="1.25"/><rect x="7" y="5" width="4" height="9.5" rx=".5" stroke="currentColor" strokeWidth="1.25"/><rect x="12" y="7" width="4" height="7.5" rx=".5" stroke="currentColor" strokeWidth="1.25"/><path d="M1.5 14.5H16.5" stroke="currentColor" strokeWidth="1.25"/></Icon>,
  education:    <Icon><path d="M2 7.5L9 4.5L16 7.5L9 10.5L2 7.5Z" stroke="currentColor" strokeWidth="1.25"/><path d="M5 9V12.5C5 12.5 6.5 14.5 9 14.5C11.5 14.5 13 12.5 13 12.5V9" stroke="currentColor" strokeWidth="1.25"/><path d="M16 7.5V12" stroke="currentColor" strokeWidth="1.4"/></Icon>,
  edtech:       <Icon><rect x="2" y="3.5" width="14" height="9.5" rx="1.5" stroke="currentColor" strokeWidth="1.25"/><path d="M6 16H12M9 13V16" stroke="currentColor" strokeWidth="1.3"/><path d="M7.5 7.5L12 9L7.5 10.5V7.5Z" stroke="currentColor" strokeWidth="1.25"/></Icon>,
  research:     <Icon><circle cx="7.8" cy="7.8" r="4.5" stroke="currentColor" strokeWidth="1.25"/><circle cx="7.8" cy="7.8" r="1.8" stroke="currentColor" strokeWidth="1.1"/><path d="M11.3 11.3L15.5 15.5" stroke="currentColor" strokeWidth="1.6"/></Icon>,
  technology:   <Icon><rect x="3" y="3" width="12" height="12" rx="2.5" stroke="currentColor" strokeWidth="1.25"/><circle cx="6.5" cy="6.5" r=".9" fill="currentColor"/><circle cx="11.5" cy="6.5" r=".9" fill="currentColor"/><circle cx="6.5" cy="11.5" r=".9" fill="currentColor"/><circle cx="11.5" cy="11.5" r=".9" fill="currentColor"/><circle cx="9" cy="9" r=".9" fill="currentColor"/><path d="M6.5 6.5L9 9M11.5 6.5L9 9M6.5 11.5L9 9M11.5 11.5L9 9" stroke="currentColor" strokeWidth=".8"/></Icon>,
  professional: <Icon><rect x="2.5" y="6" width="13" height="9.5" rx="1.5" stroke="currentColor" strokeWidth="1.25"/><path d="M6 6V4.5C6 3.7 6.7 3 7.5 3H10.5C11.3 3 12 3.7 12 4.5V6" stroke="currentColor" strokeWidth="1.25"/><path d="M2.5 10.5H15.5" stroke="currentColor" strokeWidth="1.2"/></Icon>,
  nonprofit:    <Icon><path d="M9 14.5C9 14.5 2.5 10.5 2.5 6.5C2.5 4.6 4 3 6 3C7.2 3 8.3 3.7 9 4.8C9.7 3.7 10.8 3 12 3C14 3 15.5 4.6 15.5 6.5C15.5 10.5 9 14.5 9 14.5Z" stroke="currentColor" strokeWidth="1.25"/></Icon>,
};

/* ─── Industry data ──────────────────────────────────────────────────────── */
const INDUSTRIES = [
  {
    name: "E-Commerce",
    icon: "retail",
    desc: "AI-powered commerce experiences and intelligent customer journeys.",
  },
  {
    name: "Education",
    icon: "education",
    desc: "Interactive learning systems powered by multilingual AI.",
  },
  {
    name: "Healthcare",
    icon: "health",
    desc: "Secure AI systems for patient engagement and healthcare automation.",
  },
  {
    name: "Insurance",
    icon: "insurance",
    desc: "Intelligent claims processing and customer support automation.",
  },
  {
    name: "News & Media",
    icon: "media",
    desc: "AI-enhanced content workflows and conversational experiences.",
  },
  {
    name: "Oil & Gas",
    icon: "oil",
    desc: "Operational intelligence and predictive enterprise systems.",
  },
  {
    name: "Retail",
    icon: "retail",
    desc: "Real-time customer insights and AI-driven retail engagement.",
  },
  {
    name: "Telecommunications",
    icon: "telecom",
    desc: "Scalable conversational systems and intelligent automation.",
  },
  {
    name: "Travel & Tourism",
    icon: "travel",
    desc: "AI-powered travel assistance and customer experience systems.",
  },
  {
    name: "Banking & Payments",
    icon: "banking",
    desc: "Enterprise AI infrastructure for fintech and secure automation.",
  },
];

/* ─── Animation helpers ──────────────────────────────────────────────────── */
const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] },
});

/* ─── IndustriesSlider (default export) ─────────────────────────────────── */
export default function IndustriesSlider() {
  return (
    <>
      <Styles />

      <Box
        component="section"
        aria-label="Industries We Empower"
        sx={{
          position: "relative",
          background: "#000000",
          pt: { xs: "clamp(56px, 10vw, 96px)", md: "clamp(80px, 8vw, 128px)", xl: "clamp(80px, 6vw, 112px)" },
          pb: { xs: "clamp(64px, 12vw, 112px)", md: "clamp(80px, 8vw, 140px)", xl: "clamp(80px, 6vw, 120px)" },
          overflow: "hidden",
          minHeight: 0,
        }}
      >
        {/* ── Noise grain texture ── */}
        <Box aria-hidden className="ig-grain" />

        {/* ── Top ambient orb ── */}
        <Box
          aria-hidden
          component={motion.div}
          animate={{ scale: [1, 1.14, 1], opacity: [.5, .8, .5] }}
          transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
          sx={{
            position: "absolute",
            top: { xs: "-8%", md: "-12%" },
            left: "50%",
            transform: "translateX(-50%)",
            width: { xs: "min(380px, 90vw)", sm: "min(520px, 80vw)", md: "min(720px, 70vw)", xl: 860 },
            height: { xs: "min(240px, 60vw)", sm: "min(340px, 50vw)", md: "min(480px, 40vw)", xl: 560 },
            borderRadius: "50%",
            background: "radial-gradient(ellipse, rgba(0,180,100,.07) 0%, transparent 70%)",
            filter: "blur(50px)",
            pointerEvents: "none",
          }}
        />

        {/* ── Bottom-left secondary orb ── */}
        <Box
          aria-hidden
          sx={{
            position: "absolute",
            bottom: { xs: "3%", md: "5%" },
            left: { xs: "-12%", md: "-6%", xl: "-3%" },
            width: { xs: "min(200px, 55vw)", sm: "min(320px, 45vw)", md: "min(450px, 35vw)", xl: 520 },
            height: { xs: "min(200px, 55vw)", sm: "min(320px, 45vw)", md: "min(450px, 35vw)", xl: 520 },
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(30,144,255,.10) 0%, transparent 70%)",
            filter: "blur(60px)",
            pointerEvents: "none",
          }}
        />

        {/* ── Section separator (top) ── */}
        <Box
          aria-hidden
          sx={{
            position: "absolute", top: 0,
            left: "50%", transform: "translateX(-50%)",
            width: { xs: "90%", sm: "80%", md: "60%" },
            height: "1px",
            background: "linear-gradient(to right, transparent, rgba(255,255,255,.05), transparent)",
            pointerEvents: "none",
          }}
        />

        {/* ═══════════════════ CONTENT ═══════════════════ */}
        <Container
          maxWidth="xl"
          sx={{
            position: "relative",
            zIndex: 2,
            px: {
              xs: "clamp(16px, 5vw, 24px)",
              sm: "clamp(24px, 4vw, 40px)",
              md: "clamp(32px, 4vw, 48px)",
              lg: "clamp(40px, 3vw, 56px)",
              xl: "clamp(48px, 2.5vw, 80px)",
            },
          }}
        >
          {/* ── Section header ── */}
          <Box
            sx={{
              textAlign: "center",
              mb: {
                xs: "clamp(40px, 8vw, 64px)",
                md: "clamp(56px, 7vw, 80px)",
                xl: "clamp(56px, 5vw, 72px)",
              },
            }}
          >
            {/* Overline */}
            <motion.div {...fadeUp(0)}>
              <Box
                sx={{ display: "inline-flex", alignItems: "center", gap: 1.2, mb: { xs: 2.5, md: 3.5 } }}
              >
                <Box sx={{ width: { xs: 14, md: 18 }, height: "1px", background: "rgba(30,144,255,.5)" }} />
                <Typography
                  sx={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: "clamp(0.6rem, 1.5vw, 0.7rem)",
                    fontWeight: 600,
                    color: "rgba(88,178,255,.9)",
                    letterSpacing: ".14em",
                    textTransform: "uppercase",
                  }}
                >
                  Sectors Served
                </Typography>
                <Box sx={{ width: { xs: 14, md: 18 }, height: "1px", background: "rgba(30,144,255,.5)" }} />
              </Box>
            </motion.div>

            {/* Heading */}
            <motion.div {...fadeUp(.08)}>
              <Typography
                component="h2"
                sx={{
                  fontFamily: "'Bricolage Grotesque', sans-serif",
                  fontWeight: 750,
                  fontSize: "clamp(1.7rem, 5vw, 3rem)",
                  lineHeight: 1.1,
                  letterSpacing: "clamp(-0.5px, -0.05em, -1.8px)",
                  color: "rgba(255,255,255,.93)",
                  mb: { xs: 2, md: 2.5 },
                }}
              >
                Industries We&nbsp;
                <Box
                  component="span"
                  sx={{
                    background: "#1E90FF",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  Empower
                </Box>
              </Typography>
            </motion.div>

            {/* Subtitle */}
            <motion.div {...fadeUp(.15)}>
              <Typography
                sx={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: "clamp(0.82rem, 2vw, 1rem)",
                  lineHeight: 1.82,
                  color: "rgba(255,255,255,.38)",
                  maxWidth: { xs: "92%", sm: "520px", md: "580px" },
                  mx: "auto",
                }}
              >
                Our AI solutions empower enterprises, public sector bodies, and
                educational organizations across diverse industries worldwide.
              </Typography>
            </motion.div>
          </Box>

          {/* ── Bento grid ── */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                lg: "clamp(280px, 28vw, 360px) 1fr",
                xl: "clamp(300px, 26vw, 400px) 1fr",
              },
              gap: {
                xs: "clamp(24px, 5vw, 40px)",
                lg: "clamp(24px, 3vw, 48px)",
                xl: "clamp(28px, 2.5vw, 56px)",
              },
              alignItems: "start",
            }}
          >

            {/* ── Left sticky showcase ── */}
            <Box
              sx={{
                position: { xs: "relative", lg: "sticky" },
                top: { lg: 100, xl: 120 },
                /* Prevent sticky overflow on short viewports */
                maxHeight: { lg: "calc(100vh - 140px)" },
                overflow: { lg: "visible" },
              }}
            >
              <Box
                component={motion.div}
                whileHover={{ y: -4 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
                sx={{
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: { xs: "20px", md: "24px", xl: "28px" },
                  p: {
                    xs: "clamp(20px, 5vw, 28px)",
                    md: "clamp(24px, 4vw, 32px)",
                    xl: "clamp(28px, 3vw, 40px)",
                  },
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02))",
                  border: "1px solid rgba(255,255,255,0.06)",
                  backdropFilter: "blur(18px)",
                  WebkitBackdropFilter: "blur(18px)",
                }}
              >
                {/* Inner orb */}
                <Box
                  sx={{
                    position: "absolute",
                    width: { xs: 180, md: 220, xl: 260 },
                    height: { xs: 180, md: 220, xl: 260 },
                    borderRadius: "50%",
                    background:
                      "radial-gradient(circle, rgba(30,144,255,0.14), transparent 70%)",
                    bottom: { xs: -80, md: -100, xl: -120 },
                    right: { xs: -60, md: -70, xl: -80 },
                    filter: "blur(30px)",
                    pointerEvents: "none",
                  }}
                />

                <Typography
                  sx={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: "clamp(0.65rem, 1.5vw, 0.72rem)",
                    letterSpacing: ".16em",
                    textTransform: "uppercase",
                    color: "rgba(30,144,255,.72)",
                    mb: { xs: 1.5, md: 2 },
                    fontWeight: 600,
                  }}
                >
                  Industries
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "'Bricolage Grotesque', sans-serif",
                    fontWeight: 700,
                    fontSize: "clamp(1.5rem, 4vw, 2.3rem)",
                    lineHeight: 1.05,
                    color: "rgba(255,255,255,.94)",
                    mb: { xs: 1.5, md: 2 },
                    letterSpacing: "clamp(-0.3px, -0.03em, -0.8px)",
                  }}
                >
                  Enterprise AI
                  <br />
                  Across Industries
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: "clamp(0.82rem, 2vw, 0.96rem)",
                    lineHeight: 1.9,
                    color: "rgba(255,255,255,.45)",
                    maxWidth: { xs: "100%", md: 280, xl: 300 },
                  }}
                >
                  Building intelligent enterprise systems for modern
                  industries using agentic AI, multimodal intelligence,
                  automation, and real-time infrastructure.
                </Typography>

                {/* Animated bar chart visual */}
                <Box
                  sx={{
                    mt: { xs: "clamp(24px, 5vw, 40px)", md: 5 },
                    height: { xs: "clamp(160px, 35vw, 220px)", md: 220, xl: 260 },
                    borderRadius: { xs: "16px", md: "18px", xl: "22px" },
                    position: "relative",
                    overflow: "hidden",
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,.05), rgba(255,255,255,.02))",
                    border: "1px solid rgba(255,255,255,.05)",
                    flexShrink: 0,
                  }}
                >
                  {/* Floating glow orb */}
                  <Box
                    component={motion.div}
                    animate={{
                      y: [0, -20, 0],
                      opacity: [0.7, 1, 0.7],
                    }}
                    transition={{
                      duration: 6,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                    sx={{
                      position: "absolute",
                      width: { xs: 120, md: 160, xl: 180 },
                      height: { xs: 120, md: 160, xl: 180 },
                      borderRadius: "50%",
                      background:
                        "radial-gradient(circle, rgba(30,144,255,.28), transparent 70%)",
                      left: "50%",
                      top: "50%",
                      transform: "translate(-50%, -50%)",
                      filter: "blur(18px)",
                    }}
                  />

                  {/* Animated bars */}
                  {[120, 160, 90, 190, 140].map((h, i) => (
                    <Box
                      key={i}
                      component={motion.div}
                      animate={{ y: [0, -8, 0] }}
                      transition={{
                        duration: 4 + i,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                      sx={{
                        position: "absolute",
                        bottom: { xs: 18, md: 25 },
                        left: `${18 + i * 15}%`,
                        width: { xs: "clamp(16px, 3.5vw, 24px)", md: "clamp(20px, 2.8vw, 28px)" },
                        height: { xs: h * 0.72, md: h },
                        borderRadius: "999px",
                        background:
                          "linear-gradient(to top, rgba(255,255,255,.12), rgba(30,144,255,.28))",
                        border: "1px solid rgba(255,255,255,.08)",
                        backdropFilter: "blur(10px)",
                      }}
                    />
                  ))}
                </Box>
              </Box>
            </Box>

            {/* ── Right industry cards grid ── */}
            <Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2, 1fr)",
                    md: "repeat(2, 1fr)",
                    xl: "repeat(2, 1fr)",
                  },
                  gap: {
                    xs: "clamp(10px, 3vw, 16px)",
                    sm: "clamp(12px, 2.5vw, 18px)",
                    md: "clamp(14px, 2vw, 20px)",
                    xl: "clamp(16px, 1.5vw, 24px)",
                  },
                }}
              >
                {INDUSTRIES.map((industry, index) => {
                  const IconEl = ICONS[industry.icon];

                  return (
                    <Box
                      key={industry.name}
                      component={motion.div}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true, margin: "-40px" }}
                      transition={{
                        duration: 0.45,
                        delay: index * 0.04,
                      }}
                      whileHover={{ x: 4 }}
                      className="ig-card"
                      sx={{
                        position: "relative",
                        borderRadius: { xs: "16px", md: "18px", xl: "22px" },
                        p: {
                          xs: "clamp(14px, 4vw, 20px)",
                          sm: "clamp(16px, 3vw, 22px)",
                          md: "clamp(18px, 2.5vw, 24px)",
                          xl: "clamp(20px, 2vw, 28px)",
                        },
                        background: "rgba(255,255,255,.02)",
                        border: "1px solid rgba(255,255,255,.04)",
                        backdropFilter: "blur(10px)",
                        WebkitBackdropFilter: "blur(10px)",
                        transition: "all .25s ease",
                        overflow: "hidden",
                        minHeight: { xs: "auto", sm: 0 },

                        "&:hover": {
                          borderColor: "rgba(30,144,255,.18)",
                          background: "rgba(30,144,255,.03)",
                        },
                      }}
                    >
                      {/* Scan-line element */}
                      <Box className="ig-scan" />

                      {/* Decorative corner orb */}
                      <Box
                        sx={{
                          position: "absolute",
                          width: { xs: 80, md: 100, xl: 120 },
                          height: { xs: 80, md: 100, xl: 120 },
                          borderRadius: "50%",
                          background:
                            "radial-gradient(circle, rgba(30,144,255,.08), transparent 70%)",
                          top: { xs: -35, md: -45, xl: -50 },
                          right: { xs: -35, md: -45, xl: -50 },
                          pointerEvents: "none",
                        }}
                      />

                      <Box
                        sx={{
                          display: "flex",
                          gap: { xs: "clamp(10px, 3vw, 16px)", md: 2 },
                          alignItems: "flex-start",
                        }}
                      >
                        {/* Icon */}
                        <Box
                          sx={{
                            width: { xs: "clamp(16px, 4vw, 20px)", md: 20, xl: 22 },
                            height: { xs: "clamp(16px, 4vw, 20px)", md: 20, xl: 22 },
                            color: "rgba(30,144,255,.75)",
                            flexShrink: 0,
                            mt: "2px",
                            transition: "color .22s ease",
                            ".ig-card:hover &": { color: "rgba(30,144,255,1)" },
                          }}
                        >
                          {IconEl}
                        </Box>

                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography
                            sx={{
                              fontFamily: "'Bricolage Grotesque', sans-serif",
                              fontWeight: 650,
                              fontSize: "clamp(0.82rem, 2.2vw, 1rem)",
                              color: "rgba(255,255,255,.88)",
                              mb: { xs: 0.6, md: 1 },
                              letterSpacing: "clamp(-0.1px, -0.01em, -0.3px)",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              transition: "color .22s ease",
                              ".ig-card:hover &": { color: "rgba(255,255,255,.98)" },
                            }}
                          >
                            {industry.name}
                          </Typography>

                          <Typography
                            sx={{
                              fontFamily: "'DM Sans', sans-serif",
                              fontSize: "clamp(0.75rem, 1.8vw, 0.9rem)",
                              lineHeight: 1.75,
                              color: "rgba(255,255,255,.42)",
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitLineClamp: { xs: 3, md: "unset" },
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {industry.desc}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>

          {/* ── Footer tally line ── */}
          <motion.div {...fadeUp(.3)}>
            <Box
              sx={{
                mt: {
                  xs: "clamp(40px, 8vw, 64px)",
                  md: "clamp(56px, 7vw, 80px)",
                  xl: "clamp(56px, 5vw, 72px)",
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: { xs: 1.5, md: 2.5 },
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  height: "1px",
                  background:
                    "linear-gradient(to right, transparent, rgba(255,255,255,.06))",
                }}
              />
              <Typography
                sx={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: "clamp(0.62rem, 1.5vw, 0.72rem)",
                  fontWeight: 500,
                  color: "rgba(255,255,255,.2)",
                  letterSpacing: ".07em",
                  whiteSpace: "nowrap",
                }}
              >
                {INDUSTRIES.length}&nbsp;industries &amp; counting
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  height: "1px",
                  background:
                    "linear-gradient(to left, transparent, rgba(255,255,255,.06))",
                }}
              />
            </Box>
          </motion.div>
        </Container>

        {/* ── Section separator (bottom) ── */}
        <Box
          aria-hidden
          sx={{
            position: "absolute", bottom: 0,
            left: "50%", transform: "translateX(-50%)",
            width: { xs: "90%", sm: "80%", md: "60%" },
            height: "1px",
            background:
              "linear-gradient(to right, transparent, rgba(255,255,255,.04), transparent)",
            pointerEvents: "none",
          }}
        />
      </Box>
    </>
  );
}